import React from 'react';
import './App.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './providers/auth_provider';
import Layout from './layout';
import Dashboard from './pages/dashboard';
import Login from './pages/auth/login';
import NotFound from './utils/notfoundpage';
import Profile from './pages/profile';
import UpdateAccount from './pages/profile/edit';
import ViewUser from './pages/users/profile';
import Category from './pages/category';
import Users from './pages/users';
import ViewFrequencies from './pages/frequencies/profile';
import Frequencies from './pages/frequencies';
import Subscriptions from './pages/subscriptions';
import AddMusic from './pages/music';
import UserSubscriptions from './pages/users/subscription';
import EmailTemplates from './pages/templates';
import 'react-quill/dist/quill.snow.css';
import Transactions from './pages/transactions';
import Payouts from './pages/affiliate/payouts';
import AffiliateSettings from './pages/affiliate/affiliate_settings';
import Affiliates from './pages/affiliate/user-affiliates';
import ViewReferrals from './pages/affiliate/user-affiliates/view_referrals';
import AdminAffiliates from './pages/affiliate/admin-affiliates';
import UsersDeltaAmounts from './pages/delta-amount';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <div>Loading...</div>; // Or a proper loading spinner
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <Layout>{children}</Layout>;
};

const App = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />

      <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />

      <Route path="/users" element={<ProtectedRoute><Users /></ProtectedRoute>} />
      <Route path="/users/view" element={<ProtectedRoute><ViewUser /></ProtectedRoute>} />
      <Route path="/delta-amount" element={<ProtectedRoute><UsersDeltaAmounts /></ProtectedRoute>} />

      <Route path="/user-subscriptions" element={<ProtectedRoute><UserSubscriptions /></ProtectedRoute>} />

      <Route path="/categories" element={<ProtectedRoute><Category /></ProtectedRoute>} />

      <Route path="/frequencies" element={<ProtectedRoute><Frequencies /></ProtectedRoute>} />
      <Route path="/frequencies/view" element={<ProtectedRoute><ViewFrequencies /></ProtectedRoute>} />

      <Route path="/music" element={<ProtectedRoute><AddMusic /></ProtectedRoute>} />

      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/profile/update" element={<ProtectedRoute><UpdateAccount /></ProtectedRoute>} />

      <Route path="/templates" element={<ProtectedRoute><EmailTemplates /></ProtectedRoute>} />

      <Route path="/subscriptions" element={<ProtectedRoute><Subscriptions /></ProtectedRoute>} />
      <Route path="/transactions" element={<ProtectedRoute><Transactions /></ProtectedRoute>} />

      {/* Affiliate routes */}
      <Route path="/admin/affiliates" element={<ProtectedRoute><AdminAffiliates /></ProtectedRoute>} />
      <Route path="/affiliates" element={<ProtectedRoute><Affiliates /></ProtectedRoute>} />
      <Route path="/affiliates/view" element={<ProtectedRoute><ViewReferrals /></ProtectedRoute>} />
      <Route path="/payouts" element={<ProtectedRoute><Payouts /></ProtectedRoute>} />
      <Route path="/affiliate-settings" element={<ProtectedRoute><AffiliateSettings /></ProtectedRoute>} />

      <Route path="*" element={<ProtectedRoute><NotFound /></ProtectedRoute>} />
    </Routes>
  );
};

const AppWrapper = () => {
  return (
    <AuthProvider>
      <App />
      <ToastContainer />
    </AuthProvider>
  );
};

export default AppWrapper;